import { Theme } from '@mui/material/styles';

/** Colours for the centred icon + label on Anamnesis tile cards (not the bottom overlay). */
export const getAnamnesisTileCenterColors = (theme: Theme) => {
    const isLight = theme.palette.mode === 'light';
    const foreground = theme.palette.dashboard?.heroTileForegroundColor
        ?? (isLight ? '#000000' : '#ffffff');
    const muted = theme.palette.dashboard?.heroTileLabelColor
        ?? (isLight ? 'rgba(25, 25, 25, 0.7)' : 'rgba(255, 255, 255, 0.7)');
    const textShadow = isLight ? 'none' : '0 2px 8px rgba(0,0,0,0.3)';
    return { foreground, muted, textShadow };
};
